"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _NoSsr.NoSsr;
  }
});
var _NoSsr = require("@mui/base/NoSsr");